<li *ngIf="showSubMenu" class="nav-item">
  <a class="nav-menu-item" [ngClass]="{ active: isSubMenuActive }" [id]="navMenuId">
    <i [class]="iconClass"></i>
  </a>
  <ul class="nav-sub-menu">
    <li>
      <div class="sub-menu-title-container">
        <p class="sub-menu-title">{{ subMenuTitle }}</p>
      </div>
    </li>

    <ng-container *ngFor="let item of menuItems; trackBy: trackMenuItem;">
      <li *ngIf="item.showLink"  [class]="item.hasSubMenu ? 'nav-sub-sub-menu-header nav-menu-item' : 'nav-sub-menu-item'">
        <a *ngIf="item.route && !item.isPopupSubMenu" [routerLink]="curCataLog+item.route" [queryParams]="item.queryParams" [id]="item.linkId" class="nav-link" routerLinkActive="active"  tabindex="0"
          ><i [ngClass]="{ 'nav-link-icon': item.hasSubMenu }" class="fa fa-square"></i>{{ item.name }} </a
        >
        <a *ngIf="!item.route && !item.isPopupSubMenu"  [id]="item.linkId" class="nav-link" routerLinkActive="active" tabindex="0"
          ><i [ngClass]="{ 'nav-link-icon': item.hasSubMenu }" class="fa fa-square"></i>{{ item.name }}</a
        >
        <a *ngIf="item.isPopupSubMenu" (click)="openPopupClick(item)"  [id]="item.linkId" class="nav-link" routerLinkActive="active" tabindex="0"
          ><i [ngClass]="{ 'nav-link-icon': item.hasSubMenu }" class="fa fa-square"></i>{{ item.name }}</a
        >
        <!-- Sub Menu Section -->
        <ul *ngIf="item.hasSubMenu" class="nav-sub-menu-child">
          <ng-template ngFor let-subMenuItem [ngForOf]="item?.subMenuItems">
            <li *ngIf="subMenuItem.showLink && subMenuItem.route" class="nav-sub-menu-item">
              <a class="nav-link" routerLinkActive="active" [routerLink]="curCataLog + subMenuItem.route" [queryParams]="subMenuItem.queryParams" tabindex="0" [id]="subMenuItem.linkId">
                <i [id]="item.linkId" class="fa fa-square nav-link-icon"></i> {{ subMenuItem.name }}
              </a>
            </li>
          </ng-template>
        </ul>
      </li>
    </ng-container>
  </ul>
</li>
